import {
	SettingsController,
	TransactionsController,
	WalletController,
} from '../../controllers';
import { useStores } from '../../stores';
import { monthName, theYear } from '../../utils/utils';
import React, { useEffect, useMemo, useState } from 'react';
import { MimaToastUtil } from '../../components';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import { Subwallet } from '../../pages';
import { observer } from 'mobx-react';
import { object, string } from 'yup';
import moment from 'moment';
import { getDate } from '../../utils/utils';
import { filterPeriods } from '../../utils/utils';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';

const { subWalletTransactions } = TransactionsController;
const { beneficiaries, subWalletDetails } = WalletController;
const SubwalletContainer = () => {
	const { userStore, walletStore } = useStores();
	const [loading, setLoading] = useState(false);
	const [loading2, setLoading2] = useState(false);
	const [createSubWallet, setCreateSubWalletModal] = useState(false);
	const [filterPeriod, setFilterPeriod] = useState(`${monthName} ${theYear}`);
	const [limit, setLimit] = useState(50);
	const [filterQuery, setFilterQuery] = useState('');
	const [currentPage, setCurrentPage] = useState(0);
	const [searchQuery, setSearchQuery] = useState('');

	const { needFeedback } = useGetAllActiveReviews(
		constant.FEEDBACK.PETTYCASHMAKEPAYMENT
	);

	const PettyCashTableQuery = useMemo(() => {
		return `offset=${currentPage + 1}&limit=${limit}`;
	}, [currentPage, limit]);

	const { isLoading, data, isFetching } =
		TransactionsController.useSubWalletTransactions(
			PettyCashTableQuery,
			filterQuery,
			searchQuery
		);

	const onLimitChange = limit => {
		setLimit(limit);
		setCurrentPage(0);
	};

	const navigate = useNavigate();
	const setPin = () => {
		if (!userStore.user.hasPin) {
			MimaToastUtil.error({
				message: 'Kindly set your PIN on settings page',
			});
			return navigate(constant.Routes.Settings);
		}
	};

	const refreshWallet = async () => {
		setLoading(true);
		await SettingsController.runTransactionSetup();
		setLoading(false);
	};

	const validationSchema = () => {
		return object({
			startDate: string().required('Start Date is required'),
			endDate: string().required('End Date is required'),
		});
	};
	useEffect(() => {
		const setTransactions = async () => {
			setLoading(true);
			await Promise.all([
				subWalletDetails(),
				// banks(),
				beneficiaries(),
				// SettingsController.expenseCategories(),
			]);
			setLoading(false);
		};
		setTransactions();
	}, []);

	const refresh = async () => {
		setLoading(true);
		await Promise.all([
			subWalletTransactions(),
			subWalletDetails(),
			beneficiaries(),
			// SettingsController.expenseCategories(),
		]);
		setLoading(false);
	};

	const onSubmit = async payload => {
		let query;

		if (payload && Object.keys(payload).length > 0) {
			query = `startDate=${payload.startDate}&endDate=${payload.endDate}`;
			if (payload.period === 'custom') {
				setFilterPeriod(
					`${moment(payload?.startDate).format('DD-MM-YYYY')} - ${moment(payload.endDate).format('DD-MM-YYYY')}`
				);
			} else {
				setFilterPeriod(`${payload?.periodText}`);
			}
		}
		setLoading(true);
		await Promise.all([subWalletTransactions(query), subWalletDetails()]);
		setLoading(false);
	};

	const [transferModal, setTransferModal] = useState(false);
	const [pinContent, setPinContent] = useState(false);
	const [confirmTransferContent, setConfirmTransferContent] = useState(false);
	const [transferSuccessContent, setTransferSuccessContent] = useState(false);
	const [transferFailedContent, setTransferFailedContent] = useState(false);
	const [viewMore, setViewMore] = useState(false);

	const showViewMore = () => {
		setViewMore(true);
	};

	const resetFilter = () => {
		onSubmit();
		setFilterPeriod(`${monthName} ${theYear}`);
	};
	const sharedState = {
		pinContent,
		confirmTransferContent,
		transferSuccessContent,
		transferFailedContent,
	};

	const transferSwitchState = {
		goToTransferSuccess: () => {
			setTransferSuccessContent(true);
			setConfirmTransferContent(false);
			setPinContent(false);
		},

		goToTransferFailed: () => {
			setTransferFailedContent(true);
			setTransferSuccessContent(false);
			setConfirmTransferContent(false);
			setPinContent(false);
		},

		goToConfirmTransfer: () => {
			setConfirmTransferContent(true);
			setPinContent(false);
		},

		goToConfirmPin: () => {
			setPinContent(true);
			setConfirmTransferContent(false);
		},
	};
	const addWallet = () => {
		setCreateSubWalletModal(true);
	};
	const transfer = () => {
		setPin();
		setTransferModal(true);
	};

	const closeModal = () => {
		walletStore.setSelectedSubWallet({});
		setTransferModal(false);
		setTransferSuccessContent(false);
		setTransferFailedContent(false);
		setConfirmTransferContent(false);
		setPinContent(false);
		setViewMore(false);
		setCreateSubWalletModal(false);
	};

	const receiptDLHandler = async transaction => {
		setLoading2(true);
		const { status, data } = await WalletController.getWalletReceipt(
			transaction.transfer._id
		);

		setLoading2(false);
		if (status === constant.Success) {
			window.open(data.url);
			return MimaToastUtil.success({
				message: constant.Success,
			});
		}

		return MimaToastUtil.error({
			message: 'Your receipt is being generated, try again after 60 seconds',
		});
	};

	return (
		<Subwallet
			refreshWallet={refreshWallet}
			loading={loading}
			filterPeriod={filterPeriod}
			resetFilter={resetFilter}
			refresh={refresh}
			onSubmit={onSubmit}
			validationSchema={validationSchema}
			sharedState={sharedState}
			closeWalletModal={closeModal}
			closeModal={closeModal}
			transferModal={transferModal}
			transferSwitchState={transferSwitchState}
			transfer={transfer}
			viewMore={viewMore}
			showViewMore={showViewMore}
			createSubWallet={createSubWallet}
			addWallet={addWallet}
			getDate={getDate}
			filterPeriods={filterPeriods}
			receiptDLHandler={receiptDLHandler}
			loading2={loading2}
			needFeedback={needFeedback}
			isLoading={isLoading}
			data={data}
			isFetching={isFetching}
			limit={limit}
			onLimitChange={onLimitChange}
			currentPage={currentPage}
			setCurrentPage={setCurrentPage}
			setSearchQuery={setSearchQuery}
		/>
	);
};

export default observer(SubwalletContainer);
